import React from 'react';
import LeadForm from './LeadForm';
import Solutions from './Solutions';
import Coverage from './Coverage';
import Testimonials from './Testimonials';

const ProductsSection = () => {
  return (
    <section id="products" className="py-16 lg:py-20 relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-purple-100/40 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full bg-violet-100/40 blur-3xl" />
      </div>
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-6">
          {/* Left: Lead form */}
          <div id="coverage-form" className="lg:col-span-3">
            <LeadForm />
          </div>

          {/* Center: Solutions */}
          <div className="lg:col-span-6">
            <Solutions />
          </div>

          {/* Right: Coverage */}
          <div id="coverage" className="lg:col-span-3">
            <Coverage />
          </div>
        </div>

        {/* Testimonials strip */}
        <div id="testimonials" className="mt-14">
          <Testimonials />
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
